import { render, staticRenderFns } from "./VideoListData.vue?vue&type=template&id=8496f104&scoped=true&"
import script from "./VideoListData.vue?vue&type=script&lang=js&"
export * from "./VideoListData.vue?vue&type=script&lang=js&"
import style0 from "./VideoListData.vue?vue&type=style&index=0&id=8496f104&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8496f104",
  null
  
)

export default component.exports